import {useContext} from 'react'

import ModalContext from '../components/ModalContext'

export default function useModal(modal: string) {
  const context = useContext(ModalContext)
  const isOpen = context.modal === modal

  return {
    isOpen,
    modalData: context.modalData,
    openModal: (passedData?) => context.openModal(modal, passedData),
    closeModal: () => context.closeModal(modal)
  }
}
